import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../snackbar/snackbar.service';

@Component({
  selector: 'app-dialog-cancel-reason',
  templateUrl: './dialog-cancel-reason.component.html',
  styleUrls: ['./dialog-cancel-reason.component.scss']
})
export class DialogCancelReasonComponent {
  reason: string;
  acction: string;

  reasonCtrl: FormControl;

  maxCharReason: number = 250;

  constructor(
    protected snackBarService: SnackbarService,
    public dialogRef: MatDialogRef<DialogCancelReasonComponent>,
    @Inject(MAT_DIALOG_DATA)  public data: DialogCancelReasonDATA,
  ){
    this.reasonCtrl =  new FormControl('');
    if(data.requiredReason){
      this.reasonCtrl.addValidators(Validators.required);
    }
    if(data.maxCharsReason != null){
      this.maxCharReason = data.maxCharsReason;
    }
  }

  isOk(){
    if((this.data.requiredReason 
      && (this.reasonCtrl.value == null || this.reasonCtrl.value.trim() == ''))
      || this.reasonCtrl.invalid
    ){
      this.reasonCtrl.markAsTouched();
      if(this.data.requiredMessage != null){
        this.snackBarService.openSnackBarCheck(this.data.requiredMessage);
      }
      return;
    }

    const resp: DialogCancelReasonResponse = {
      reason: this.reasonCtrl.value || '',
      isOk: true,
      action: 'ACCEPT'
    }
    this.dialogRef.close(resp);
  }
  close(){
    const resp: DialogCancelReasonResponse = {
      isOk: false,
      action: 'CANCEL'
    }
    this.dialogRef.close(resp);
  }
}

export interface DialogCancelReasonDATA{
  lblTitle: string;
  lblReason: string;
  phReason: string;
  lblOk: string;
  lblClose: string;
  maxCharsReason: number;
  requiredReason: boolean;
  requiredMessage?: string;
  requiredHelper?: string;
}

export interface DialogCancelReasonResponse{
  reason?: string;
  isOk: boolean;
  action: string;
}
